module.exports = __webpack_public_path__ + "static/img/lixianrenwu2.dec0876.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/lixianrenwu2.png
// module id = ZEzg
// module chunks = 24